import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../utils/api";

const PaymentStatus = () => {
  const { orderId } = useParams(); // actually txnId
  const navigate = useNavigate();
  const [status, setStatus] = useState("CHECKING");

  useEffect(() => {
    verify();
  }, []);

  const verify = async () => {
    try {
      const res = await api.get(
        `/api/payment/phonepe/status/${orderId}`
      );

      if (res.data.status === "SUCCESS") {
        setStatus("SUCCESS");
        setTimeout(() => {
          navigate(`/order-confirmation/${res.data.orderId}`);
        }, 1500);
      } else {
        setStatus("FAILED");
      }
    } catch {
      setStatus("FAILED");
    }
  };

  return (
    <div className="container text-center py-5">
      {status === "CHECKING" && <h4>Verifying Payment…</h4>}
      {status === "SUCCESS" && (
        <h2 className="text-success">Payment Successful 🎉</h2>
      )}
      {status === "FAILED" && (
        <>
          <h2 className="text-danger">Payment Failed ❌</h2>
          <button
            className="btn btn-warning"
            onClick={() => navigate("/ShopCart")}
          >
            Retry
          </button>
        </>
      )}
    </div>
  );
};

export default PaymentStatus;